import React, { useState, useEffect } from "react";
import { Alert, Modal, DropdownButton, MenuItem, Button } from 'ui';
import { useUpdateSurveyQuestion } from 'hooks/surveys/mutations/useUpdateSurveyQuestion';

const EditQuestionModal = ({ question_type, question_id, surveyId, onHide, hasEditPermission }) => {
    const [newQuestionType, setNewQuestionType] = useState(question_type);
    const [error, setError] = useState(null);

    // Use the extracted mutation hook
    const updateQuestionMutation = useUpdateSurveyQuestion(surveyId, {
        onSuccess: (result) => {
            onHide();
            setError(null);
        },
        onError: (error) => {
            setError(error.response?.data?.error || "An error occurred while saving changes.");
        }
    });

    const handleSelect = (eventKey) => {
        setNewQuestionType(eventKey);
    };

    useEffect(() => {
        setNewQuestionType(question_type);
    }, [question_type])

    const saveChanges = () => {
        setError(null);
        updateQuestionMutation.mutate({ 
            questionId: question_id, 
            questionType: newQuestionType 
        });
    }

    const getQuestionType = (question_type) => {
        switch (question_type) {
            case "text":
                return "Long Text";
            case "single_choice":
                return "Single Choice";
            default:
                return "Unknown";
        }
    }

    // TODO: This does not work perfectly, because hasEditPermission defaults to false
    // Ideally this would be null first, but I like that this is hidden from view only people
    useEffect(()=>{
        if ( !question_id ) return;
        if ( hasEditPermission === false ) onHide();
    }, [question_id, onHide, hasEditPermission])

    return (
        <Modal show={!!question_id} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Edit Question</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {error && <Alert variant="warning">{error}</Alert>}
                <p>Dropdown questions can be used as filters, and long text can be coded.</p>

                <div className="mb-3">
                    <label>Change question type</label>
                    &nbsp;
                    <DropdownButton
                        id="dropdown-basic-button"
                        title={getQuestionType(newQuestionType)}
                        onSelect={handleSelect}
                        variant="white"
                    >
                        <MenuItem eventKey="text">{getQuestionType('text')}</MenuItem>
                        <MenuItem eventKey="single_choice">{getQuestionType('single_choice')}</MenuItem>
                    </DropdownButton>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button 
                    variant="blue" 
                    onClick={saveChanges} 
                    disabled={updateQuestionMutation.isPending}
                >
                    {updateQuestionMutation.isPending ? 'Saving...' : 'Save Changes'}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditQuestionModal;